import React from 'react';

const DailyReport = () => {
	return (
		<div>
			<h1>Daily Report Under Construction</h1>
		</div>
	);
};

export default DailyReport;
